import { ReactNode, useMemo } from "react";

import { Address } from "@/types/api/shared";
import { formatAddressMarkup } from "@/utils/format";

const useFormatAddress = (
  name: string,
  address: Address,
  hideName?: boolean
): ReactNode => {
  const addressFormatted = useMemo<ReactNode>(() => {
    return formatAddressMarkup(name, address, hideName);
  }, [name, address, hideName]);
  return addressFormatted;
};

export default useFormatAddress;
